export default "__VITE_ASSET__DU6nmBR6__"